var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerSalvadorCaetanoAvailable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.059,
    height: 60,
    viewBox: "0 0 50.059 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 28.605,
    height: 30.122,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-70 -94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M-93.867-47.357A22.858,22.858,0,0,0-116.934-70,22.858,22.858,0,0,0-140-47.357C-140-32.639-116.934-10-116.934-10s23.066-22.639,23.066-37.357",
    transform: "translate(210 164)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(78.823 100.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22-2",
    "data-name": "Group 22",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16045",
    "data-name": "Path 16045",
    d: "M68.86,2.362a11.433,11.433,0,0,1,2.8-.732c.289-.039.526-.073.628-.468a1.629,1.629,0,0,1,3.141.074c-.012,1.593.111,2.944.1,4.537-.111-.015-.372.244-.464.195-1.834-.974-3.669-1.948-5.49-2.946-.276-.151-.654-.246-.708-.659",
    transform: "translate(-59.476 0.001)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16046",
    "data-name": "Path 16046",
    d: "M25.395,170a12.94,12.94,0,0,1-4.6-3.988c1.724.665,2.84-.149,2.606-1.9a16.422,16.422,0,0,0,2.44,2.365,14.672,14.672,0,0,0-.131,2.841c0,.281,0,.554-.315.683",
    transform: "translate(-17.961 -141.745)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16047",
    "data-name": "Path 16047",
    d: "M59.028,17.334c.054.413.432.508.708.659,1.821,1,3.656,1.971,5.49,2.946a1.02,1.02,0,0,0,.33.048q0,.748,0,1.495a22.309,22.309,0,0,1-3.088-1.5,1.987,1.987,0,0,0-.5-.89,3.457,3.457,0,0,0-1.294.084,26.9,26.9,0,0,0-2.719-1.568c-.226-.134-.608-.182-.423-.61a5.419,5.419,0,0,1,1.5-.664",
    transform: "translate(-49.644 -14.972)",
    fill: "#39434a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16048",
    "data-name": "Path 16048",
    d: "M167.811,37.2a13.1,13.1,0,0,1,3.332,4.249l-.33-.118a1.613,1.613,0,0,0-2.518,1.119c-.034.129-.029.27-.147.364a12.58,12.58,0,0,0-1.279-1.948c.184-.925.344-1.855.564-2.771.073-.306,0-.705.377-.895",
    transform: "translate(-144.128 -32.127)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16049",
    "data-name": "Path 16049",
    d: "M19.944,148.614c.234,1.752-.882,2.566-2.606,1.9a1.476,1.476,0,0,1-.545-.773,12.739,12.739,0,0,1,.639-1.4c.424-.7.521-1.573,1.133-2.175l1.38,2.445",
    transform: "translate(-14.504 -126.249)",
    fill: "#6ac5fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16050",
    "data-name": "Path 16050",
    d: "M118.041,12.142a7.97,7.97,0,0,1,2.841.663c-.029.2-.059.4-.086.6a25.056,25.056,0,0,0-.462,2.648c-.745-.285-1.507.035-2.292-.1,0-1.09,0-2.717,0-3.806",
    transform: "translate(-101.953 -10.487)",
    fill: "#6ac5fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16051",
    "data-name": "Path 16051",
    d: "M174.323,146.011a1.036,1.036,0,0,1-.248.558,15.059,15.059,0,0,1-2.643.249c-.4.043-.879.266-1.266-.113l1.3-2.133a3.225,3.225,0,0,1,1.11-.461c1.209.226,1.511.555,1.745,1.9",
    transform: "translate(-146.975 -124.47)",
    fill: "#6ac5fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16052",
    "data-name": "Path 16052",
    d: "M.129,86.258a13.643,13.643,0,0,1,.725-6.451c.26.81.587,1.56,1.572,1.7-.326.737-.614,1.493-.988,2.2A10.405,10.405,0,0,1,.129,86.258",
    transform: "translate(0 -68.931)",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16053",
    "data-name": "Path 16053",
    d: "M7.836,73.139c-.985-.138-1.312-.887-1.572-1.7a3.428,3.428,0,0,1,.6-1.32c.248.1.5.2.745.3A23.064,23.064,0,0,0,9.768,71.5a3.784,3.784,0,0,1-.431,1.065l-.966.553-.535.024",
    transform: "translate(-5.41 -60.566)",
    fill: "#69c4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16054",
    "data-name": "Path 16054",
    d: "M96.88,9.484q0,1.635,0,3.27c-.015,1.513-.037,3.027-.04,4.54a1.939,1.939,0,0,1-.414,1.318,8.218,8.218,0,0,0-1.484-.791,1.757,1.757,0,0,1-1.327-2.35c.829.445,1.661.886,2.486,1.339.385.211.64.244.614-.322-.018-.382-.008-.765-.011-1.148q0-.747,0-1.495.017-2.39.035-4.78l.14.419",
    transform: "translate(-80.792 -7.83)",
    fill: "#47697e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16055",
    "data-name": "Path 16055",
    d: "M47.5,22.208c-.186.428.2.477.422.61a26.954,26.954,0,0,1,2.719,1.567l-1.651.675c-1-.334-1.84-1-2.8-1.417a.513.513,0,0,1-.318-.479,5.831,5.831,0,0,1,1.632-.957",
    transform: "translate(-39.617 -19.181)",
    fill: "#415866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16056",
    "data-name": "Path 16056",
    d: "M5.229,88.588l.966-.552a17.07,17.07,0,0,0-.662,3.154.768.768,0,0,0-.413.424c-.587,1.32-1.187,2.633-1.761,3.958a1.016,1.016,0,0,1-.406.516,4.568,4.568,0,0,1-.326-1.2c.24-.087.318-.31.412-.511.248-.529.485-1.064.728-1.6C4.282,91.655,4.819,90.54,5.3,89.4c.092-.219.532-.6-.067-.812",
    transform: "translate(-2.268 -76.038)",
    fill: "#47687c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16057",
    "data-name": "Path 16057",
    d: "M180.831,120.029a3.229,3.229,0,0,0-1.11.461l.554-1.817c.436-.1.7-.462,1.048-.694a13.784,13.784,0,0,1,2.354-1.75q.014.615.028,1.229l-.029.263a12.581,12.581,0,0,0-2.844,2.307",
    transform: "translate(-155.228 -100.39)",
    fill: "#3b4951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16058",
    "data-name": "Path 16058",
    d: "M3.756,92.089c.6.214.159.593.067.812-.477,1.14-1.015,2.255-1.53,3.379-.244.531-.48,1.066-.728,1.6-.094.2-.173.423-.412.511a4.925,4.925,0,0,1-.229-1.52,10.41,10.41,0,0,0,1.309-2.548c.374-.712.662-1.468.988-2.2l.535-.024",
    transform: "translate(-0.796 -79.539)",
    fill: "#3d4f59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16059",
    "data-name": "Path 16059",
    d: "M114.041,198.455a2.207,2.207,0,0,1-1.217.132c.02-.469.045-.934.1-1.4a3.492,3.492,0,0,0-.09-1.846.841.841,0,0,1,.678-.11,3.835,3.835,0,0,1,.953.517l.395.565c.039.187-.01.393.124.559a2.24,2.24,0,0,1-.941,1.587",
    transform: "translate(-97.448 -168.604)",
    fill: "#62afdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16060",
    "data-name": "Path 16060",
    d: "M66.441,191.449a4.832,4.832,0,0,1-1.637-.563,7.535,7.535,0,0,0,.283-1.9c.029-.487-.135-.994.126-1.461l1.5.65a31.824,31.824,0,0,0-.274,3.276",
    transform: "translate(-55.972 -161.968)",
    fill: "#415866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16061",
    "data-name": "Path 16061",
    d: "M38.063,29.232a.513.513,0,0,0,.318.479c.963.416,1.8,1.083,2.8,1.417l-1.62.979c-.406-.646-1.173-.718-1.747-1.1-.362-.24-.859-.318-.986-.835a4.621,4.621,0,0,1,1.231-.943",
    transform: "translate(-31.812 -25.248)",
    fill: "#486b81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16062",
    "data-name": "Path 16062",
    d: "M13.595,61.97a23.132,23.132,0,0,1-2.155-1.078c-.249-.1-.5-.2-.745-.3a4.949,4.949,0,0,1,.832-1.5A8.626,8.626,0,0,0,14.389,60.6l-.795,1.371",
    transform: "translate(-9.237 -51.038)",
    fill: "#62b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16063",
    "data-name": "Path 16063",
    d: "M56.355,182.289c-.261.467-.1.974-.126,1.461a7.535,7.535,0,0,1-.283,1.9,4.543,4.543,0,0,1-1.4-.664c.319-.129.314-.4.315-.683a14.661,14.661,0,0,1,.131-2.841l1.362.826",
    transform: "translate(-47.114 -156.733)",
    fill: "#394248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16064",
    "data-name": "Path 16064",
    d: "M118.814,189.748a3.835,3.835,0,0,0-.952-.517,17.025,17.025,0,0,0,2.585-.713,1.952,1.952,0,0,0,1.37.107c1.513-.15,3.024-.308,4.544-.36a4.258,4.258,0,0,1-1,.949c-.061-.378-.362-.285-.588-.273-.381.02-.758.1-1.138.126-1.347.1-2.7.169-4.04.3-.261.026-.67-.047-.778.38",
    transform: "translate(-101.799 -162.608)",
    fill: "#456375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16065",
    "data-name": "Path 16065",
    d: "M121.756,205.917a2.24,2.24,0,0,0,.941-1.587c.949-.487,2-.251,3-.422a1.464,1.464,0,0,1,1.107.1,12.136,12.136,0,0,1-5.05,1.912",
    transform: "translate(-105.163 -176.066)",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16066",
    "data-name": "Path 16066",
    d: "M187.867,129.486a12.581,12.581,0,0,1,2.844-2.307,12.338,12.338,0,0,1-.664,3.1c-.141.369-.29.736-.435,1.1-.234-1.346-.536-1.675-1.745-1.9",
    transform: "translate(-162.264 -109.847)",
    fill: "#343435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16067",
    "data-name": "Path 16067",
    d: "M76.815,195.567a31.826,31.826,0,0,1,.274-3.276l.956.273c.112.132.279.216.276.435-.011.764,0,1.528-.014,2.292a.489.489,0,0,1-.414.535,2.38,2.38,0,0,1-1.078-.26",
    transform: "translate(-66.346 -166.085)",
    fill: "#496c82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16068",
    "data-name": "Path 16068",
    d: "M28.9,36.148c.127.517.624.6.986.835.574.38,1.341.451,1.747,1.1a5.2,5.2,0,0,1-.988.792,26.717,26.717,0,0,0-3-1.5A5.2,5.2,0,0,1,28.9,36.148",
    transform: "translate(-23.884 -31.222)",
    fill: "#4e7c99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16069",
    "data-name": "Path 16069",
    d: "M19.661,53.517A8.625,8.625,0,0,1,16.8,52.009a3.935,3.935,0,0,1,.8-1.118A7.343,7.343,0,0,0,20.5,52.437l-.844,1.08",
    transform: "translate(-14.509 -43.955)",
    fill: "#5b9dc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16070",
    "data-name": "Path 16070",
    d: "M187.188,107.536a13.789,13.789,0,0,0-2.354,1.75c-.349.232-.612.593-1.048.694l.167-1.088c.069-.138.1-.329.213-.406,1.047-.728,1.943-1.654,3.036-2.321a.072.072,0,0,1,.013.1q-.014.635-.027,1.27",
    transform: "translate(-158.739 -91.696)",
    fill: "#435c6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16071",
    "data-name": "Path 16071",
    d: "M152.6,176.246c-.305.352-.465.819-.865,1.1-.433-.3-.9-.126-1.355-.094a23.131,23.131,0,0,1-3.725.2l1.35-.961a2.7,2.7,0,0,0,.717.062c1.289-.134,2.584-.208,3.877-.3",
    transform: "translate(-126.666 -152.227)",
    fill: "#5184a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16072",
    "data-name": "Path 16072",
    d: "M101.545,196.162a3.492,3.492,0,0,1,.09,1.846c-.054.469-.079.934-.1,1.4a3.283,3.283,0,0,1-1.781.032c.451.048.6-.168.563-.6a3.822,3.822,0,0,1,.008-1.082c.111-.528-.057-1.132.393-1.575l.825-.025",
    transform: "translate(-86.16 -169.428)",
    fill: "#5b9cc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16073",
    "data-name": "Path 16073",
    d: "M161.156,169.948c-1.293.1-2.588.17-3.877.3a2.7,2.7,0,0,1-.717-.062l.991-.935a23.911,23.911,0,0,0,3.231-.253c.294-.036.639-.14.892.157a2.115,2.115,0,0,1-.52.789",
    transform: "translate(-135.225 -145.929)",
    fill: "#5a9cc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16074",
    "data-name": "Path 16074",
    d: "M124.851,193.91c.108-.427.517-.354.778-.38,1.343-.133,2.693-.2,4.04-.3.38-.028.757-.106,1.138-.126.227-.012.528-.1.588.273a2.794,2.794,0,0,1-.824.652c-.033-.249-.214-.268-.4-.244-1.494.191-2.992.341-4.5.4a.469.469,0,0,0-.424.288l-.395-.565",
    transform: "translate(-107.836 -166.769)",
    fill: "#3f5460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16075",
    "data-name": "Path 16075",
    d: "M25.567,47.45A7.346,7.346,0,0,1,22.659,45.9a2.176,2.176,0,0,1,.68-.787,26.718,26.718,0,0,1,3,1.5,3.276,3.276,0,0,1-.768.83",
    transform: "translate(-19.571 -38.968)",
    fill: "#558eb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16076",
    "data-name": "Path 16076",
    d: "M84.722,197.555a.489.489,0,0,0,.414-.535c.018-.764,0-1.528.014-2.292,0-.219-.165-.3-.276-.435l1.5.27q-.069,1.617-.137,3.233a3.564,3.564,0,0,1-1.513-.241",
    transform: "translate(-73.176 -167.813)",
    fill: "#507f9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16077",
    "data-name": "Path 16077",
    d: "M185.791,82.158a2.521,2.521,0,0,1,.378,1.224c-.3-.173-.466.106-.636.231-.556.41-1.047.912-1.621,1.291a1.2,1.2,0,0,0-.587,1.234l-.378-2.207c.357.232.577-.032.824-.222a18.226,18.226,0,0,1,2.021-1.55",
    transform: "translate(-158.014 -70.961)",
    fill: "#548aab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16078",
    "data-name": "Path 16078",
    d: "M138.17,183.308a23.133,23.133,0,0,0,3.725-.2c.457-.032.922-.2,1.355.094a1.58,1.58,0,0,1-.5.541c-1.52.052-3.031.21-4.544.36a1.954,1.954,0,0,1-1.37-.107l1.338-.689",
    transform: "translate(-118.184 -158.086)",
    fill: "#4b728b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16079",
    "data-name": "Path 16079",
    d: "M5.018,116.077a1.017,1.017,0,0,0,.406-.516C6,114.236,6.6,112.922,7.185,111.6a.768.768,0,0,1,.413-.424q0,.6,0,1.2-.918,2.04-1.838,4.08c-.093.2-.175.432-.46.441a2.512,2.512,0,0,1-.282-.82",
    transform: "translate(-4.334 -96.027)",
    fill: "#4e7b97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16080",
    "data-name": "Path 16080",
    d: "M185.669,93.545a1.2,1.2,0,0,1,.587-1.234c.574-.379,1.065-.881,1.621-1.291.169-.125.337-.4.636-.231a2.416,2.416,0,0,1,.172.957,3.9,3.9,0,0,0-.623.4,11.918,11.918,0,0,1-2.369,1.777q-.012-.192-.024-.384",
    transform: "translate(-160.358 -78.369)",
    fill: "#4d7a95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16081",
    "data-name": "Path 16081",
    d: "M185.134,100.345a11.916,11.916,0,0,0,2.369-1.777,3.9,3.9,0,0,1,.623-.4l.137,1.09c-1.093.667-1.989,1.593-3.036,2.321-.111.077-.144.268-.213.406l.121-1.636",
    transform: "translate(-159.799 -84.785)",
    fill: "#486a80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16082",
    "data-name": "Path 16082",
    d: "M14.452,139.237c-.612.6-.709,1.472-1.133,2.175a12.729,12.729,0,0,0-.639,1.4,3.254,3.254,0,0,1-.649-1.123c.553-.163.552-.718.776-1.11a9.782,9.782,0,0,1,1.257-2.434,4.172,4.172,0,0,1,.388,1.094",
    transform: "translate(-10.391 -119.316)",
    fill: "#61aedd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16083",
    "data-name": "Path 16083",
    d: "M167.959,163.285c-.252-.3-.6-.193-.892-.157a23.951,23.951,0,0,1-3.231.253l.863-1.092c.386.379.866.156,1.266.113a15.059,15.059,0,0,0,2.643-.249,2.871,2.871,0,0,1-.649,1.131",
    transform: "translate(-141.508 -140.055)",
    fill: "#63b3e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16084",
    "data-name": "Path 16084",
    d: "M183.885,76.1a18.229,18.229,0,0,0-2.021,1.55c-.247.19-.466.455-.824.222a2.713,2.713,0,0,1-.3-.954c.339.166.522-.091.757-.257a9.713,9.713,0,0,1,2.087-1.517,1.993,1.993,0,0,1,.3.956",
    transform: "translate(-156.107 -64.905)",
    fill: "#5a99c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16085",
    "data-name": "Path 16085",
    d: "M95.826,199.506q.068-1.617.137-3.233l1.363.01c-.45.443-.282,1.047-.393,1.575a3.822,3.822,0,0,0-.008,1.082c.035.431-.112.647-.563.6l-.535-.033",
    transform: "translate(-82.767 -169.524)",
    fill: "#558daf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16086",
    "data-name": "Path 16086",
    d: "M181.052,68.547a9.709,9.709,0,0,0-2.087,1.517c-.235.166-.418.423-.757.257a3.264,3.264,0,0,1-.4-.956c.086.022.205.091.253.058a6.855,6.855,0,0,0,2.2-1.917l.33.118a3.048,3.048,0,0,1,.461.923",
    transform: "translate(-153.576 -58.306)",
    fill: "#5fa7d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16087",
    "data-name": "Path 16087",
    d: "M127.749,198.862a.469.469,0,0,1,.424-.288c1.506-.063,3-.213,4.5-.4.19-.024.371,0,.4.244-.4.175-.627.617-1.093.681a1.465,1.465,0,0,0-1.107-.1c-1,.171-2.052-.065-3,.422-.135-.165-.086-.372-.124-.559",
    transform: "translate(-110.339 -171.156)",
    fill: "#394248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16088",
    "data-name": "Path 16088",
    d: "M163.39,32.952c-.376.19-.3.589-.377.895-.22.916-.381,1.846-.564,2.771l-.7-.782a28.264,28.264,0,0,1,.786-3.553,2.93,2.93,0,0,1,.853.67",
    transform: "translate(-139.707 -27.883)",
    fill: "#3b484f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16089",
    "data-name": "Path 16089",
    d: "M157.456,29.459a28.262,28.262,0,0,0-.786,3.553l-.8-.717c.181-.848.357-1.7.547-2.545.065-.289.031-.651.443-.737a1.188,1.188,0,0,1,.6.445",
    transform: "translate(-134.626 -25.06)",
    fill: "#445f71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16090",
    "data-name": "Path 16090",
    d: "M7.085,124.489c.285-.009.368-.237.46-.441q.923-2.038,1.838-4.08a4.089,4.089,0,0,1,.127,1.242c-.5,1.1-1,2.2-1.513,3.284-.14.294-.208.652-.546.821a2.016,2.016,0,0,1-.367-.827",
    transform: "translate(-6.119 -103.619)",
    fill: "#558daf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16091",
    "data-name": "Path 16091",
    d: "M9.78,133.187c.338-.169.406-.527.546-.821.518-1.088,1.011-2.188,1.513-3.284a4.664,4.664,0,0,1,.281,1.235,9.782,9.782,0,0,0-1.257,2.434c-.224.392-.223.947-.776,1.11a1.213,1.213,0,0,1-.307-.674",
    transform: "translate(-8.447 -111.49)",
    fill: "#5b9dc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16092",
    "data-name": "Path 16092",
    d: "M140.557,19.246a1.717,1.717,0,0,1,.821.38l-.685,3.276-.815-.426a24.634,24.634,0,0,0,.679-3.23",
    transform: "translate(-120.815 -16.623)",
    fill: "#5a9ac2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16093",
    "data-name": "Path 16093",
    d: "M136.232,17.311a24.638,24.638,0,0,1-.679,3.23l-.682-.29a25.063,25.063,0,0,1,.462-2.648c.028-.2.057-.4.086-.6a1.74,1.74,0,0,1,.813.305",
    transform: "translate(-116.49 -14.688)",
    fill: "#62b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16094",
    "data-name": "Path 16094",
    d: "M152.5,25.67c-.412.086-.378.448-.443.737-.19.846-.365,1.7-.547,2.545l-.688-.525c.049-.24.082-.484.149-.719a13.585,13.585,0,0,1,.677-2.565,2.226,2.226,0,0,1,.851.528",
    transform: "translate(-130.265 -21.716)",
    fill: "#4b748d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16095",
    "data-name": "Path 16095",
    d: "M147.362,22.455a13.585,13.585,0,0,0-.677,2.565c-.068.235-.1.479-.149.719l-.676-.431.685-3.277c.243.2.617.144.817.424",
    transform: "translate(-125.982 -19.029)",
    fill: "#5287a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16096",
    "data-name": "Path 16096",
    d: "M208.751,108.179q.013-.635.027-1.27a6.139,6.139,0,0,1,0,2.5q-.014-.615-.028-1.229",
    transform: "translate(-180.302 -92.339)",
    fill: "#486a80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16097",
    "data-name": "Path 16097",
    d: "M97.172,45.6c0,.383-.007.766.011,1.148.026.567-.229.533-.614.322-.825-.453-1.657-.893-2.486-1.338q0-.815,0-1.631a22.29,22.29,0,0,0,3.088,1.5",
    transform: "translate(-81.261 -38.09)",
    fill: "#405663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16098",
    "data-name": "Path 16098",
    d: "M93.071,37.349q0,.816,0,1.632A1.757,1.757,0,0,0,94.4,41.33a8.208,8.208,0,0,1,1.484.791,1.333,1.333,0,0,1-1.567.634,1.479,1.479,0,0,1-1.289-1.233,11.518,11.518,0,0,1-.078-2.106c-.023-1.044-.4-1.632-.412-2.676.285.32.439.26.536.608",
    transform: "translate(-80.248 -31.339)",
    fill: "#4f7c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16099",
    "data-name": "Path 16099",
    d: "M176.463,67.778a.553.553,0,0,1-.212-.377c.118-.093.114-.234.147-.363a1.613,1.613,0,0,1,2.518-1.119,6.856,6.856,0,0,1-2.2,1.917c-.048.033-.167-.036-.253-.058",
    transform: "translate(-152.231 -56.719)",
    fill: "#64b5e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Union_1",
    "data-name": "Union 1",
    transform: "translate(77.871 99.125)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.555,27.913A14.927,14.927,0,0,1,.13,17.21,15.348,15.348,0,0,1,4.559,6.364a14.936,14.936,0,0,1,8.447-4.325A2.588,2.588,0,0,1,15.3.4a2.591,2.591,0,0,1,2.3,1.657A14.937,14.937,0,0,1,25.95,6.364,15.348,15.348,0,0,1,30.38,17.21a14.915,14.915,0,0,1-4.435,10.7,15.121,15.121,0,0,1-10.7,4.351A15.088,15.088,0,0,1,4.555,27.913ZM5.135,17.2A10.174,10.174,0,0,0,8.1,24.449a10.166,10.166,0,0,0,14.311,0A10.161,10.161,0,0,0,25.375,17.2,10.361,10.361,0,0,0,17.9,7.176v3.74a2.592,2.592,0,1,1-5.157,0V7.137A10.33,10.33,0,0,0,5.135,17.2Z",
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1431",
    "data-name": "Ellipse 1431",
    cx: 7.169,
    cy: 7.169,
    r: 7.169,
    transform: "translate(105.722 96.461)",
    fill: "#2fff66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSalvadorCaetanoAvailable);
export default __webpack_public_path__ + "static/media/marker_salvadorCaetano_available.9ff6b163d16a15eb97452220f77f622a.svg";
export { ForwardRef as ReactComponent };